import { Inline } from '@gitbook/slate';

import { INLINE_EXPRESSION } from '../types';

export function createExpression(expression: string = ''): Inline {
    return Inline.createVoid({
        type: INLINE_EXPRESSION,
        data: { expression },
    });
}
